import { Controller } from "@hotwired/stimulus"

// Toggles search / filter regions between collapsed and expanded.
// Supports multiple independently-toggleable panels via the targets:
//   - input: the search region (legacy single-toggle)
//   - search: dedicated search region
//   - filter: dedicated filter region
export default class extends Controller {
  static targets = ["input", "search", "filter"]

  toggle() {
    this.toggleTarget(this.hasInputTarget ? this.inputTarget : null)
  }

  toggleSearch() {
    this.toggleTarget(this.hasSearchTarget ? this.searchTarget : null)
  }

  toggleFilter() {
    this.toggleTarget(this.hasFilterTarget ? this.filterTarget : null)
  }

  toggleTarget(target) {
    if (!target) return
    const hidden = target.classList.toggle("hidden")
    if (!hidden) {
      const focusable = target.querySelector("input[type=search], input[type=text], select")
      if (focusable) focusable.focus()
    }
  }
}
